import {
  SORT_DIRECTIONS,
  GOOGLE_TAG_MANAGER_AUTH,
  GOOGLE_TAG_MANAGER_ENV,
  GOOGLE_TAG_MANAGER_ID,
} from '../constants';

export const isStatusOk = response => response.status === 200; // we need to modify this based on our real situation

export const strToKebab = str => {
  const words = str.toLowerCase().split(/\s+/);
  return words.join('-');
};

export const sortObjectByKey = (key, direction) => (a, b) => {
  const aVal = a[key];
  const bVal = b[key];

  switch (direction) {
    case SORT_DIRECTIONS.DESC:
      if (aVal > bVal) return -1;
      if (aVal < bVal) return 1;
      return 0;
    case SORT_DIRECTIONS.ASC:
    default:
      if (aVal > bVal) return 1;
      if (aVal < bVal) return -1;
      return 0;
  }
};

export const redirectToUrl = (url, openInNewTab) => {
  if (openInNewTab) {
    window.open(url, '_blank');
  } else {
    window.location.replace(url);
  }
};

export const constructGTM = extraArgs => {
  const tagManagerArgs = {
    gtmId: GOOGLE_TAG_MANAGER_ID,
    ...extraArgs,
  };
  if (GOOGLE_TAG_MANAGER_AUTH) tagManagerArgs.auth = GOOGLE_TAG_MANAGER_AUTH;
  if (GOOGLE_TAG_MANAGER_ENV) tagManagerArgs.preview = GOOGLE_TAG_MANAGER_ENV;

  return tagManagerArgs;
};

export const isEmptyString = str => {
  if (str.replace(/\s/g, '') === '') {
    return true;
  }
  return false;
};

// eslint-disable-next-line consistent-return
export const maskMobileNumber = number => {
  if (number.length <= 4) {
    return number;
  }

  if (number.length <= 7) {
    // eslint-disable-next-line prettier/prettier
    return `${number.slice(0, 4)} ${number.slice(4, number.length)}`;
  }

  // eslint-disable-next-line prettier/prettier
  return `${number.slice(0, 4)} ${number.slice(4, 7)} ${number.slice(
    7,
    number.length,
  )}`;
};

// eslint-disable-next-line consistent-return
export const maskLandLineNumber = number => {
  if (number.length <= 2) {
    return number;
  }

  if (number.length <= 6) {
    // eslint-disable-next-line prettier/prettier
    return `${number.slice(0, 2)} ${number.slice(2, number.length)}`;
  }

  // eslint-disable-next-line prettier/prettier
  return `${number.slice(0, 2)} ${number.slice(2, 6)} ${number.slice(
    6,
    number.length,
  )}`;
};

export const normalizePhoneNumber = value => {
  if (!value) {
    return value;
  }

  const onlyNums = value.replace(/[^\d]/g, '');

  if (onlyNums.startsWith('04')) {
    return maskMobileNumber(onlyNums);
  }

  return maskLandLineNumber(onlyNums);
};

export const normalizeMobileNumber = value => {
  if (!value) {
    return value;
  }

  const onlyNums = value.replace(/[^\d]/g, '');

  return maskMobileNumber(onlyNums);
};

export const preparePhoneNumberForBackend = phoneNumber =>
  phoneNumber ? `+61${phoneNumber.replace(/^0/, '').replace(/\s/g, '')}` : '';

export const preparePhoneNumberForFrontend = phoneNumber => {
  // remove +61 and prepend 0
  const formattedNumber = phoneNumber.replace(/^\+61/, '0');

  return formattedNumber;
  // add spaces
  // if (formattedNumber.startsWith('04')) {
  //   // eslint-disable-next-line prettier/prettier
  //   return `${formattedNumber.slice(0, 4)} ${formattedNumber.slice(
  //     4,
  //     7,
  //   )} ${formattedNumber.slice(7, 10)}`;
  // }
  // // eslint-disable-next-line prettier/prettier
  // return `${formattedNumber.slice(0, 2)} ${formattedNumber.slice(
  //   2,
  //   6,
  // )} ${formattedNumber.slice(6, 10)}`;
};

// format a string as 'Sentence case' (capitalize first word only).
export const sentenceCase = string =>
  string[0].toUpperCase() + string.slice(1).toLowerCase();
